import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useUserContext } from '../../contexts/User.context';
import { SituacaoTour } from '../../models/Tour.model';
import { TipoUsuario } from '../../models/Usuario';
import { AppRoutes, Routes } from '../../routes/index.routes';
import { PjGuidedTourProvider, usePjGuidedTour } from '../components/PjGuidedTour';

const AutomaticGuidedTour = () => {
  const { loading, user, userInfo, userClaim } = useUserContext();
  const location = useLocation();
  const navigate = useNavigate();
  const { startTour } = usePjGuidedTour();
  const checkedAccount = useRef<string | null>(null);

  useEffect(() => {
    if (loading || !user || location.pathname.startsWith('/cadastro')) return undefined;

    const pessoaFisica = userClaim === TipoUsuario.PESSOA_FISICA && 'rg' in user;
    const pessoaJuridica = userClaim === TipoUsuario.PESSOA_JURIDICA && 'cnpj' in user;
    if (!pessoaFisica && !pessoaJuridica) return undefined;
    if (user.situacaoTour !== SituacaoTour.Pendente) return undefined;

    const accountIdentity = userInfo?.id || userInfo?.email || '';
    let accountKey: string;
    if (pessoaFisica && 'rg' in user) accountKey = `pf:${user.cpf}:${accountIdentity}`;
    else if (pessoaJuridica && 'cnpj' in user)
      accountKey = `pj:${user.cnpj}:${user.idSetor}:${accountIdentity}`;
    else return undefined;
    if (checkedAccount.current === accountKey) return undefined;
    checkedAccount.current = accountKey;

    if (pessoaJuridica) startTour(Routes.Home);
    else navigate(Routes.Home, { replace: true, state: { startWalletTour: true } });

    return undefined;
  }, [
    loading,
    user,
    userInfo?.id,
    userInfo?.email,
    userClaim,
    location.pathname,
    navigate,
    startTour
  ]);

  return null;
};

function App() {
  /*   const appInsights = useAppInsightsContext();
  const metricData = {
    average: 60,
    name: 'React Component Engaged Time (seconds)',
    sampleCount: 1
  };
  const additionalProperties = { 'Component Name': 'App' };
  appInsights.trackMetric(metricData, additionalProperties); */

  return (
    <PjGuidedTourProvider
      routes={{
        home: Routes.Home,
        users: Routes.Usuarios.Principal,
        transactions: Routes.Transacoes.Principal,
        postpaid: Routes.Extrato.Principal
      }}
    >
      <AppRoutes />
      <AutomaticGuidedTour />
    </PjGuidedTourProvider>
  );
}

export default App;
